import React, { useEffect } from 'react';
import AnnouncementForm from '../AnnouncementForm/AnnouncementForm';
import DesiginationForm from '../DesiginationForm/DesiginationForm';
import LeaveForm from '../LeaveForm/LeaveForm';
import OffboardingTaskForm from '../OffboardingTaskForm/OffboardingTaskForm';
import OffboardingTemplateForm from '../OffboardingTemplateForm/OffboardingTemplateForm';
import OfferletterForm from '../OfferletterForm/OfferletterForm';
import RegistrationForm from '../RegistrationForm/RegistrationForm';
import $ from 'jquery';

function SideNavBar({ form, editData, handleData, templateId, messageType, desiginationId, hideContainer, setHideContainer }) {
    const [showContainer, setShowContainer] = React.useState(true);

    useEffect(() => {
        $('body,html').css('overflow', 'hidden');
        setShowContainer(hideContainer);
    }, [hideContainer]);

    const setHideForm = () => {
        $('body,html').css('overflow', '');
        setShowContainer(true);
        setHideContainer(true);
    };

    const renderForm = React.useMemo(() => {
        switch (form) {
            case 'leave':
                return (
                    <LeaveForm
                        editData={editData}
                        handleData={(data) => {
                            handleData(data);
                        }}
                        hideContainer={() => setHideForm()}
                    />
                );
            case 'announcement':
                return (
                    <AnnouncementForm
                        handleData={(data) => {
                            handleData(data);
                        }}
                        editData={editData}
                        hideContainer={() => setHideForm()}
                    />
                );
            case 'offboardingTemplate':
                return (
                    <OffboardingTemplateForm
                        editData={editData}
                        handleData={(data) => {
                            handleData(data);
                        }}
                        hideContainer={() => setHideForm()}
                    />
                );
            case 'templateTask':
                return (
                    <OffboardingTaskForm
                        tId={templateId}
                        handleData={(data) => {
                            handleData(data);
                        }}
                        editData={editData}
                        hideContainer={() => setHideForm()}
                    />
                );
            case 'registrationMessage':
                return (
                    <RegistrationForm
                        editData={editData}
                        handleData={(data) => {
                            handleData(data);
                        }}
                        messageType={messageType}
                        hideContainer={() => setHideForm()}
                    />
                );
            case 'DesignationForm':
                return (
                    <DesiginationForm
                        id={desiginationId}
                        editData={editData}
                        handleData={(data) => {
                            handleData(data);
                        }}
                        hideContainer={() => setHideForm()}
                    />
                );
            case 'offerletter':
                return (
                    <OfferletterForm
                        handleData={(data) => {
                            handleData(data);
                        }}
                        editData={editData}
                        hideContainer={() => setHideForm()}
                    />
                );
            default:
                break;
        }
    }, [form, editData, handleData, templateId, messageType, desiginationId]);

    return (
        <div>
            <div
                className="offcanvas offcanvas-end admin-announcement-offcanvas ps-3 show"
                style={{ visibility: 'visible' }}
                //, backgroundColor: 'rgba(0,0,0,0.6)'
                hidden={showContainer == undefined ? true : showContainer}
            >
                {renderForm}
            </div>
            <div className="overlay"></div>
        </div>
    );
}

export default SideNavBar;
